
//获取工作列表

export async function getWorkDetail(id:number): Promise<object> {
    
    const obj = {
        url: RequestAPI.GET_WORK_DETAIL,
        body: {
            workId: id   
        }
    }

    try{
        const {data} = await postRequired(obj);
        if(data.value.code){
            if(data.value.code === 2000){
                return data.value.data
            }
        } 
    }catch(e){
        console.log(e)
    }
    return {};

}